/** Údaje na úhradu faktúry - `contracts.invoicing.payment_notice`. */
export type PaymentNotice = {
  number: string
  total: string
  currency: string
  variable_symbol: string
  due: string
  pay_by: string
  suspend_on: string
  iban: string
  beneficiary: string
  qr: string
  school?: string
}

/** Využitie balíčka v sezóne - `contracts.usage`. Len informácia, nič sa
 *  neblokuje. `null`, keď balíček limit nemá (skúšobná verzia, Premium). */
export type PlanUsage = {
  plan: string
  plan_name: string
  season: string
  limit: number
  peak_limit: number | null
  peak_days: number
  peak_days_allowed: number
  over_cap_days: number
  max_per_day: number
  level: 'ok' | 'near' | 'over'
  recent_peak_days: string[]
  over_cap_dates: string[]
}

export const SUSPENDED_EVENT = 'l2s:suspended'

/** Balíček školy a prechod na iný - `contracts.upgrade.preview`. */
export type PlanMode = 'order' | 'upgrade' | 'request'

export type PlanOption = {
  key: string
  name: string
  /** Ročná cena bez DPH podľa cenníka; Premium ju nemá. */
  price: string | null
  instructors?: number
  /** Čo sa zaplatí teraz, bez DPH: celá objednávka alebo doplatok. */
  amount?: string | null
  /** Zľava za skorú objednávku, keď platí: percentá, ročná cena po zľave
   *  a posledný deň, do ktorého objednávka zľavu dostane. */
  discount_percent?: string | null
  discounted_price?: string | null
  discount_until?: string | null
}

export type PlanPayment = {
  plan: string
  plan_name: string
  amount: string
  variable_symbol: string
  iban: string
  swift: string
  beneficiary: string
  qr_url: string
  proforma_url: string
  contract_url: string
  paid_from: string
  /** Dá sa zaplatiť aj kartou (Stripe prevádzkovateľa). */
  card?: boolean
}

export type PlanOverview = {
  plan: string
  plan_name: string
  mode: PlanMode
  options: PlanOption[]
  others: PlanOption[]
  remaining_from: string | null
  remaining_to: string | null
  payment: PlanPayment | null
  /** Otvorená alebo nedávno vybavená požiadavka (`contracts.upgrade.request_row`). */
  request: PlanRequestRow | null
}

export type PlanRequestRow = {
  id: number
  plan: string
  plan_name: string
  note: string
  requested_by: string
  state: 'open' | 'done'
  created: string
  resolved_at: string | null
  reply: string
}

export type PlanChangeResult = {
  mode: PlanMode
  plan: string
  payment?: PlanPayment | null
  invoice?: { number: string; total: string; due: string } | null
}
